import { ScaleIcon } from '@heroicons/react/24/outline';
import { useFlag } from '@/hooks/useFeatureFlags';
import { CriteriaEditor } from './CriteriaEditor';

/**
 * Service criteria (task 1180): the standing rules every result of every test
 * is measured against — what a per-test expectation could never say. Edited in
 * place at the top of the Testing tab, through `/endpoints/:id/test-criteria`.
 * Required criteria gate pass / fail; informational ones are scored and trended.
 */
export function ServiceCriteriaSection({ endpointId }: { endpointId: string }) {
  // The flag-off single-scroll layout's criteria card answers to the same
  // criteria lever as the sections layout (task 1215).
  const criteriaEnabled = useFlag('innovate.fe.testing.criteria');
  if (!criteriaEnabled) return null;
  return (
    <section
      data-testid="service-criteria"
      className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700"
    >
      <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white flex items-center">
          <ScaleIcon className="h-5 w-5 mr-2 text-gray-400" />
          Service criteria
          <span className="ml-2 text-sm font-normal text-gray-500 dark:text-gray-400">
            — measured on every result of every scenario
          </span>
        </h3>
      </div>
      <div className="px-4 py-3">
        <CriteriaEditor
          scope={{ kind: 'service', endpointId }}
          emptyText="No service criteria yet. Add a check or a graded criterion every response must honor."
        />
      </div>
    </section>
  );
}

export default ServiceCriteriaSection;
